import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';

@Component({
    selector: 'platform-not-found',
    templateUrl: './not-found.component.html',
    standalone: false,
})
export class NotFoundComponent implements OnInit {
    private route = inject(ActivatedRoute);

    recommendedPath = '';
    ngOnInit(): void {
        this.route.data.pipe(take(1)).subscribe(data => {
            this.recommendedPath = data['path'];
        });
    }
}
